import { render, staticRenderFns } from "./open-item.vue?vue&type=template&id=406752d0&scoped=true&"
import script from "./open-item.vue?vue&type=script&lang=js&"
export * from "./open-item.vue?vue&type=script&lang=js&"
import style0 from "./open-item.vue?vue&type=style&index=0&id=406752d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406752d0",
  null
  
)

export default component.exports